import styled from 'styled-components';
import FlavourConfig from '../../../../shared/config/flavours';

const AccessBackground = styled.div<React.CSSProperties>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: ${() =>
    `url(${FlavourConfig.images.access || FlavourConfig.images.background})`};
`;

export default AccessBackground;
